import React from "react";
import { getYear } from "../helper/helper";
import { PlayIcon, PauseIcon } from "@heroicons/react/24/solid";

export default function PlaylistItem({
  image,
  title,
  name,
  publish_date,
  released,
  cast,
  artist,
  duration,
  duration_time,
  isActive,
  dark = false
}) {
  const songTitle = title || name || "Track Title";
  const songArtist = cast || artist || "Unknown Artist";
  const songYear = getYear(publish_date || released || "2023");
  const songDuration = duration || duration_time || "3:45";

  return (
    <tr
      className={`!cursor-pointer transition-all duration-300 ${
        dark
          ? `hover:!bg-zinc-850/60 ${isActive ? "!bg-zinc-800/40 border-l-2 border-secondary" : "!bg-zinc-900/40"} ${!isActive ? "!text-zinc-300" : "!text-secondary font-semibold"}`
          : `hover:!bg-orange-50/50 ${isActive ? "!bg-orange-50 border-l-2 border-secondary" : "!bg-white"} ${!isActive ? "!text-gray-800" : "!text-secondary font-semibold"}`
      } border-b ${dark ? "border-zinc-800/60" : "border-gray-100"}`}
    >
      {/* Title & Cover */}
      <td className="px-5 py-4 text-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0 w-11 h-11 relative group">
            <img
              className="w-full h-full rounded-md shadow-md object-cover border border-zinc-700/30"
              src={
                image ||
                "https://bab-digital.design-services-online.com/bab-digital-dev/public/storage/admin/feature_images/ehWYQFcTFdaCiccLWgfIGAMLZ2oA1CnAu48DX3Im.jpg"
              }
              alt={songTitle}
            />
            <div className="absolute inset-0 bg-black/40 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-350 flex items-center justify-center">
              {isActive ? (
                <PauseIcon className="h-5 w-5 text-white animate-pulse" />
              ) : (
                <PlayIcon className="h-5 w-5 text-white hover:scale-115 transition-transform" />
              )}
            </div>
          </div>
          <div className="ml-4 flex items-center gap-3">
            <span className="text-xs md:text-sm font-semibold tracking-wide block">
              {songTitle}
            </span>
            {isActive && (
              <div className="flex items-end gap-[3px] h-[18px] w-6 pb-[2px]">
                <span className="soundwave-bar animate-soundwave-1"></span>
                <span className="soundwave-bar animate-soundwave-2"></span>
                <span className="soundwave-bar animate-soundwave-3"></span>
                <span className="soundwave-bar animate-soundwave-4"></span>
              </div>
            )}
          </div>
        </div>
      </td>

      {/* Artist */}
      <td className="px-5 text-center py-4 text-sm">
        <span className={`text-xs md:text-sm font-medium ${dark ? "text-zinc-400" : "text-gray-600"}`}>
          {songArtist}
        </span>
      </td>

      {/* Released Year */}
      <td className="px-5 py-4 text-center text-sm">
        <span className={`text-xs md:text-sm font-medium ${dark ? "text-zinc-500" : "text-gray-500"}`}>
          {songYear}
        </span>
      </td>

      {/* Duration & Play Hover Action */}
      <td className="px-5 text-center py-4 text-xs md:text-sm">
        <span className={`font-semibold ${isActive ? "text-secondary" : dark ? "text-zinc-400" : "text-gray-500"}`}>
          {songDuration}
        </span>
      </td>
    </tr>
  );
}

